import styled, { css } from 'styled-components';
import { SEASONAL_RULE_COLOR_HEX } from 'models/seasonality/SeasonalRuleColors';
import { SeasonalRuleColor } from 'models/seasonality/SeasonalRule';

export const SeasonalRuleViewContainer = styled.div<{
  $leftPx: number;
  $widthPx: number;
  $color: SeasonalRuleColor;
}>`
  position: absolute;
  top: 0;
  left: ${({ $leftPx }) => $leftPx}px;
  width: ${({ $widthPx }) => $widthPx}px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  pointer-events: auto;
  z-index: 2;
  color: ${({ $color }) => SEASONAL_RULE_COLOR_HEX[$color]};
  font-size: 13px;
  font-family: SourceSansPro_light, sans-serif;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SeasonalRuleTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  max-width: 260px;
`;

export const SeasonalRuleTooltipName = styled.div`
  font-weight: 600;
`;

export const SeasonalRuleTooltipSectionTitle = styled.div`
  font-weight: 600;
  margin-top: 4px;
`;

export const SeasonalRuleTooltipRow = styled.div`
  line-height: 1.35;
`;

export const SeasonalRuleRowLayerStyles = css`
  .stacked-calendar-body-row {
    position: relative;
  }
`;
